export * from './consultingDoctor.service';